module.exports = __webpack_public_path__ + "static/postgresql-50156c71fb2cf47d5cfe134231975922.png";